module.exports = __webpack_public_path__ + "static/work_icon_design-6273951e0f7a72156c986e859f6b8038.png";